const About = () => {
  return (
    <>
      <div className="page-header">
        <h1>About Us</h1>
      </div>
      <div className="page-content">
        <p>Cron Generator by Dev5.dev is a simple tool to help you create cron expressions without the headache. Just pick your schedule and get the exact cron syntax instantly.</p>
        <p>Built by Ravi at Dev5.dev, it’s made for developers who want things done quickly and correctly.</p>
        <p>Have feedback or ideas?<br />
        <strong>Contact:</strong> ravi9793 [@] gmail.com</p>
      </div>
    </>
  )
}
export default About;